import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #FILE-UPLOAD
\*------------------------------------ */
/**
 * 1) Form field that consists of a label, text input, and field note
 */
/**
 * File upload label
 */
.cat-c-file-upload__label {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  display: block;
  margin-block-end: var(--cat-space-x-small);
}

/**
   * File upload label text
   */
.cat-c-file-upload__label-text {
  margin-block-end: var(--cat-space-x-small);
  /**
   * Hide label text
   */
}
.cat-c-file-upload--hidden-label .cat-c-file-upload__label-text {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
   * Dragging state
  */
.cat-is-dragging .cat-c-file-upload__body {
  background: var(--cat-theme-color-background-disabled);
  position: relative;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  gap: var(--cat-space-x-small);
  justify-content: center;
  text-align: center;
  border: var(--cat-theme-border-width) dashed var(--cat-theme-color-border-default);
}

/**
 * Content inside of file upload area
 */
.cat-c-file-upload__body {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  position: relative;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: var(--cat-space-x-small);
  justify-content: center;
  padding: var(--cat-space-medium);
  text-align: center;
  border: var(--cat-theme-border-width) dashed var(--cat-theme-color-border-default);
  /**
   * "Button" variant
   */
}
.cat-c-file-upload--button .cat-c-file-upload__body {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: flex;
  flex-flow: row nowrap;
  text-align: start;
  align-items: center;
  hyphens: auto;
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-button-contrast-background);
  min-height: var(--cat-line-height-40);
  border: var(--cat-theme-border-width) solid var(--cat-theme-color-button-contrast-border-active);
  border-radius: var(--cat-theme-border-radius);
  padding: var(--cat-space-x-small) var(--cat-space-medium);
}
.cat-c-file-upload--button.cat-c-file-upload--disabled .cat-c-file-upload__body {
  background-color: var(--cat-theme-color-background-default-disabled);
  border: var(--cat-theme-border-width) solid var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload__body:has(.cat-c-file-upload__input:focus) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-file-upload__body:has(.cat-c-file-upload__input:focus-visible) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-file-upload__body .cat-c-file-upload__description {
  display: flex;
  text-align: start;
  gap: var(--cat-space-x-small);
}

.cat-c-file-upload--button .cat-c-file-upload__body:hover {
  background-color: var(--cat-theme-color-button-contrast-background-hover);
}

.cat-c-file-upload--button.cat-c-file_upload_active .cat-c-file-upload__body {
  background-color: var(--cat-theme-color-button-contrast-background-active);
  border: 1px solid var(--cat-theme-color-button-icon-strong-border-hover);
}
.cat-c-file-upload--button.cat-c-file_upload_active .cat-c-file-upload__body:has(.cat-c-file-upload__input:focus) {
  outline: none;
}

/**
 * Disabled state
 */
.cat-c-file-upload--disabled {
  cursor: not-allowed;
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__list {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__list .cat-c-file-upload__status--failed {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__list .cat-c-file-upload__status--success {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__list .cat-c-file-upload__close-button {
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__label {
  pointer-events: none;
}

/**
 * Disabled body & input
 */
.cat-c-file-upload--disabled .cat-c-file-upload__body,
.cat-c-file-upload--disabled .cat-c-file-upload__input {
  cursor: not-allowed;
}

/**
 * Disabled fieldnote
 */
cat-field-note {
  --cat-field-note-margin-block-start: 0;
  --cat-theme-color-content-brand: var(--cat-theme-color-content-subtle);
  line-height: var(--cat-line-height-16);
}
.cat-c-file-upload--disabled cat-field-note {
  --cat-theme-color-content-brand: var(--cat-theme-color-content-disabled);
}

.cat-file-upload-fieldNote {
  display: flex;
  --cat-theme-color-content-brand: var(--cat-theme-color-content-default);
}

/**
 * Slotted content that appears in the drop zone
 */
.cat-c-file-upload__body slot {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  align-items: center;
}

/**
 * Button styles
 */
.cat-file-upload-button,
::slotted(cat-button) {
  z-index: 2;
  --cat-theme-color-button-default-content: var(--cat-theme-color-content-knockout);
  --cat-theme-color-button-default-background: var(--cat-color-neutral-70);
  /**
   * Disabled button
   */
}
.cat-c-file-upload--disabled .cat-file-upload-button,
.cat-c-file-upload--disabled ::slotted(cat-button) {
  --cat-theme-color-button-content: var(--cat-theme-color-content-disabled);
  --cat-theme-color-button-background: var(--cat-theme-color-background-default-disabled);
  --cat-theme-color-button-border: var(--cat-theme-color-border-disabled);
}

cat-loading-indicator {
  display: block;
  margin-inline-end: var(--cat-space-x-small);
}

/**
 * Optional upload icon
 */
.cat-file-upload-icon,
::slotted(cat-icon),
::slotted(.cat-icon) {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  /**
   * Button variant icon size
   */
  /**
   * Disabled icon
   */
}
.cat-c-file-upload--button .cat-file-upload-icon,
.cat-c-file-upload--button ::slotted(cat-icon),
.cat-c-file-upload--button ::slotted(.cat-icon) {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
}
.cat-c-file-upload--disabled .cat-file-upload-icon,
.cat-c-file-upload--disabled ::slotted(cat-icon),
.cat-c-file-upload--disabled ::slotted(.cat-icon) {
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
}

/**
 * File upload input
 */
.cat-c-file-upload__input {
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: none;
  z-index: 2;
  opacity: 0;
}

/**
 * File upload list
 */
.cat-c-file-upload__list {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  list-style: none;
  margin: var(--cat-space-x-small) 0 0;
  padding: 0;
}

/**
 * Uploaded list item headings
 */
.cat-c-file-upload__item cat-heading {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  --cat-font-size-16: var(--cat-font-size-14);
  margin-block-end: var(--cat-space-3x-small);
}

/**
 * Uploaded items first group heading
 */
h3.cat-c-file-upload__item-first {
  padding-inline-start: var(--cat-space-x-small);
}

/**
 * Uploaded list item grouping
 */
.cat-c-file-upload__item-first {
  padding: var(--cat-space-2x-small) var(--cat-space-medium);
}

.cat-c-file-upload__item-second {
  padding: var(--cat-space-2x-small) var(--cat-space-medium);
  overflow: hidden;
}

.cat-c-file-upload__item-third {
  width: 25%;
}

.cat-c-file-upload__item-first__title,
.cat-c-file-upload__item-second__title,
.cat-c-file-upload__item-third__title {
  padding: var(--cat-space-3x-small) var(--cat-space-medium);
  font-size: var(--cat-font-size-14);
  font-weight: var(--cat-font-weight-semibold);
  line-height: var(--cat-line-height-20);
  color: var(--cat-theme-color-content-default);
}

/**
 * In mobile view, only status icon is shown
 */
@media all and (max-width: 35rem) {
  span[part=uploading-text],
  [part=success-text],
  [part=status-text] {
    display: none;
  }
}
.cat-c-file-upload__list-small-table {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  list-style: none;
  margin: var(--cat-space-x-small) 0 0;
  padding: 0;
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table {
  display: flex;
  align-items: center;
  padding: var(--cat-space-medium);
  max-width: calc(var(--size-base-unit) * 47.5);
  width: auto;
  justify-content: space-between;
  outline: var(--cat-theme-border-width) solid var(--cat-theme-color-border-default);
  margin-block-end: var(--cat-space-x-small);
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table .cat-c-file-upload__small-table {
  width: 75%;
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table .cat-c-file-upload__small-table .cat-c-file-upload__name-container {
  display: flex;
  align-items: center;
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table .cat-c-file-upload__item-second {
  margin-block-start: var(--cat-space-x-small);
  padding: 0;
  width: unset;
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table .cat-c-file-upload__item-second .cat-c-file-upload__status-text {
  margin-inline-start: 3px;
}

.cat-c-drop_text {
  line-height: var(--cat-line-height-40);
}

/**
 * File name of uploaded item
 */
.cat-c-file-upload__item-text {
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cat-c-file-upload__small-table .cat-c-file-upload__name-container--remove {
  display: flex;
  align-items: center;
  color: var(--cat-theme-color-content-disabled);
}

/**
 * Upload status
 */
.cat-c-file-upload__status {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /**
   * Status icon
   */
  /**
   * Status text in tabular format
   */
  /**
   * Success  
   */
  /**
   * Failed
   */
  /**
   * Removed
   */
}
.cat-c-file-upload__status cat-icon,
.cat-c-file-upload__status .cat-icon {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  margin-inline-end: var(--cat-space-x-small);
}
@media all and (max-width: 48rem) {
  .cat-c-file-upload__status cat-icon,
  .cat-c-file-upload__status .cat-icon {
    margin-block-start: 3px;
  }
}
.cat-c-file-upload__status .cat-c-tabular-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cat-c-file-upload__status--success {
  color: var(--cat-theme-color-content-utility-success);
}
.cat-c-file-upload__status--failed {
  color: var(--cat-theme-color-content-utility-error);
}
.cat-c-file-upload__status--removed {
  color: var(--cat-color-neutral-60);
}

/**
 * Prefixed icon of uploaded item
 */
.cat-c-file-upload__icon {
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  height: var(--cat-icon-height);
  width: var(--cat-icon-width);
  margin-inline-end: var(--cat-space-x-small);
}

/**
 * File upload close button
 */
.cat-c-file-upload__close-button {
  --cat-icon-fill: var(--cat-color-utility-red);
  --cat-button-padding: calc(var(--size-base-unit) * 0.625) var(--cat-space-medium);
}

.cat-c-file-upload:not(.cat-c-file-upload--has-field-note) .cat-file-upload-fieldNote, .cat-c-file-upload:not(.cat-c-file-upload--has-error) .cat-file-upload-error-slot {
  display: none;
}
`;
       